module.exports = __webpack_public_path__ + "static/media/Stadtgang02.4f29d4d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Stadtgang02.jpg
// module id = 353
// module chunks = 0